import React, { useEffect, useState, useMemo } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { VehicleService } from "../../../service/vehicle-service";
// import SearchInputText from "../../shared/search-input-text";
import { NUMBER } from "../../../constants/app-constants";
import { STEP_NAMES } from "../pre-delivery-inspection-vehicle-info-screen/constants";
import { SearchInput } from "@cars24/turbo-web/lib/search-input";
import { Label } from "@cars24/turbo-web/lib/label";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { Chips } from "@cars24/turbo-web/lib/chips";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { sendCustomGaEvents } from "../../../tracking";
import { pdiManualFlowModel } from "../../../constants/tracking-constants/pre-delivery-inspection";
import IconSpinner from "../../shared/icon-spinner";

const ModelsList = ({
    brand,
    setDetailsConnect,
    model: selectedModel
}) => {
    const { tokens } = useTokens();
    const [isLoading, setIsLoading] = useState(false);
    const { id: brandId = ""  } = brand;
    const { id: modelId = ""} = selectedModel;
    const [searchText, setSearchText] = useState("");
    const [modelsData, setModelsData] = useState([]);

    const filteredModels = useMemo(() => {
        if (!searchText) {
            return modelsData;
        }
        return modelsData.filter((item) =>
            item.model_display.toLowerCase().includes(searchText.toLowerCase())
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchText, modelsData]);

    useEffect(() => {
        setIsLoading(true);
        if (brandId) {
            VehicleService.fetchModels(brandId)
                .then((response) => {
                    setModelsData(response?.data?.detail);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [brandId]);

    const handleSelectModel = async ({ name, id }) => {
        setDetailsConnect({
            [STEP_NAMES.Model]: { name, id },
            activeAccordionStepIndex: NUMBER.ONE,
            ownerName: ""
        });
        await yieldToMain();
        sendCustomGaEvents({
            ...pdiManualFlowModel,
            eventLabel: name
        });
    };

    const handleSelectModelClick = (model) => {
        handleSelectModel({
            name: model.model_display,
            id: model.model_id
        });
    };

    const popularModels = useMemo(
        () => filteredModels?.filter((model) => model.is_popular === "yes").slice(0, NUMBER.SIX),
        [filteredModels]
    );

    if (isLoading) return <div styleName={"styles.loadingIcon"}><IconSpinner/></div>;

    return (
        <div>
            <div styleName={"styles.searchField"}>
                <SearchInput placeholder="Search car model"  value={searchText}  onChange={(e) => setSearchText(e.target.value)} showCross={false} />
            </div>
            <div styleName={"styles.scrollWrapper"}>
                {((popularModels && popularModels.length) || (filteredModels && filteredModels.length)) ?
                    <React.Fragment>
                        <div styleName={"styles.subheadingContainer"}>
                            <Label level={NUMBER.FOUR} color={tokens.text_default_text_secondary} fontWeight="regular">Popular models</Label>
                        </div>
                        <ul styleName={"styles.brandsList styles.popularModels"}>
                            {popularModels && !!popularModels.length && popularModels.map((model, i) => (
                                <Chips
                                    key={`model-${i}`}
                                    onClick={() => handleSelectModelClick(model)}
                                    label={model?.model_display}
                                    isActive={model.model_id === modelId}
                                    size="large"
                                />
                            ))}
                        </ul>
                        <div styleName={"styles.subheadingContainer"}>
                            <Label level={NUMBER.FOUR} color={tokens.text_default_text_secondary} fontWeight="regular">All models</Label>
                        </div>
                        <ul styleName={"styles.brandsList"}>
                            {filteredModels && !!filteredModels.length && filteredModels.map((model, i) => (
                                <div key={`all-models-list-${i}`} styleName={`styles.brandlistCard ${model.model_id === modelId ? "styles.active" : ""}`} onClick={() => handleSelectModelClick(model)}>
                                    <BodyText level={NUMBER.THREE}>{model.model_display}</BodyText>
                                </div>
                            ))}
                        </ul>
                    </React.Fragment> :
                    <Label level={NUMBER.FOUR} color={tokens.text_default_text_secondary} fontWeight="regular">No results found</Label>}
            </div>
        </div>
    );
};

ModelsList.propTypes = {
    setDetailsConnect: PropTypes.func,
    brand: PropTypes.object,
    model: PropTypes.object
};

export default ModelsList;
